import React, { Component } from 'react';
import Calendar from '../../Part_Sample/Calendar';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/Common';

export default class History_Change_Filter extends Component {
	constructor(props) {
		super(props);

		let history_data = JSON.parse(JSON.stringify(this.props.param.history_data));

		let selected_date = new Date();
		if (this.props.param.search_date != null) selected_date = this.props.param.search_date;
		// Default to desc order
		let order = 'desc';
		let type = 'none';
		let command = 'none';
		let target = 'none';
		let data = 'none';
		let operator = 'none';
		if (!isEmpty(this.props.param.filters)) {
			if (this.props.param.filters.order != null) order = this.props.param.filters.order;
			if (this.props.param.filters.type != null) type = this.props.param.filters.type;
			if (this.props.param.filters.command != null) command = this.props.param.filters.command;
			if (this.props.param.filters.target != null) target = this.props.param.filters.target;
			if (this.props.param.filters.data != null) data = this.props.param.filters.data;
			if (this.props.param.filters.operator != null) operator = this.props.param.filters.operator;
		}


		if (this.props.param.order != null) order = this.props.param.order;

		this.state = {
			selected_date: selected_date,
			history_data: history_data,

			order: order,
			type: type,
			command: command,
			target: target,
			data: data,
			operator: operator,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('History', this.props.param);
	}

	handleChangeCalDate = (selected_date) => {
		this.setState({ selected_date: selected_date });

		let search_date = {
			year: selected_date.getFullYear(),
			month: selected_date.getMonth() + 1,
			day: selected_date.getDate()
		}

		this.props.receiver.getHistory(search_date);
	}

	getFilter = (index) => {
		/*
		 * Filters index
		 * 0 = timestamp
		 * 1 = type
		 * 2 = command
		 * 3 = point id/function id (target)
		 * 4 = data
		 * 5 = operator (i.e. who)
		 */
		let options = this.getFilterOptions(index);

		let range = [];
		range.push(<option value={'none'}>{this.props.receiver.getString('none')}</option>);

		// For target selection, display the point name
		if (index == 3) {
			for (let j in options) {
				let point_info = window.app.state.point_list[options[j]];
				if (!isEmpty(point_info)) {
					range.push(<option value={options[j]}>{point_info.name}</option>);
				} else {
					range.push(<option value={options[j]}>{options[j]}</option>);
				}
			}
		} else {
			for (let j in options) {
				range.push(<option value={options[j]}>{this.props.receiver.getString(options[j])}</option>);
			}
		}

		return range;
	}

	getFilterOptions = (index) => {
		let options = [];
		for (let i in this.state.history_data) {
			if (!options.includes(this.state.history_data[i][index]) && this.state.history_data[i][index] != '') {
				options.push(this.state.history_data[i][index]);
			}
		}

		return options;
	}

	handleChangeOrder = (val) => {
		let order = this.state.order;
		let history_data = this.state.history_data;

		if (this.state.order != val) {
			history_data.reverse();
		}
		this.setState({
			order: val,
			history_data: history_data
		})
	}

	handleChangeType = (val) => {
		this.setState({ type: val })
	}

	handleChangeCommand = (val) => {
		this.setState({ command: val })
	}

	handleChangeTarget = (val) => {
		this.setState({ target: val })
	}

	handleChangeData = (val) => {
		this.setState({ data: val })
	}

	handleChangeOperator = (val) => {
		this.setState({ operator: val })
	}

	handleRegister = () => {
		let param = JSON.parse(JSON.stringify(this.props.param))
		param.filters = {};
		// If filter selected is none, remove it from filters
		if (this.state.type != 'none') param.filters.type = this.state.type;
		if (this.state.command != 'none') param.filters.command = this.state.command;
		if (this.state.target != 'none') param.filters.target = this.state.target;
		if (this.state.data != 'none') param.filters.data = this.state.data;
		if (this.state.operator != 'none') param.filters.operator = this.state.operator;
		param.filters.order = this.state.order;
		param.history_data = this.state.history_data;
		param.search_date = this.state.selected_date;
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.showLoading();
		this.props.content_handler('History', param);
	}

	rcvHistory = (history_data) => {
		if (history_data == null || history_data.length < 1) {
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
		}

		this.setState({
			history_data: history_data,
			// order: 'asc',
			type: 'none',
			command: 'none',
			target: 'none',
			data: 'none',
			operator: 'none',
		});
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		let header_style = {
			marginTop: 20,
			marginLeft: 'auto',
			marginRight: 'auto',
			width: this.props.width - 80,
			textAlign: 'left',
		}

		let content_line_style = {
			width: this.props.width - 80,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			padding: 15,
			verticalAlign: 'top'
		}

		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let cal_width = is_landscape ? this.props.width - 93 : this.props.width - 40;
		let cal_height = 200;

		const type_range = this.getFilter(1);
		const command_range = this.getFilter(2);
		const target_range = this.getFilter(3);
		//const data_range = this.getFilter(4);
		const operator_range = this.getFilter(5);

		const order_range = [];
		order_range.push(<option value={'asc'}>{this.props.receiver.getString('ascending')}</option>);
		order_range.push(<option value={'desc'}>{this.props.receiver.getString('descending')}</option>);

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('history')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ height: this.props.height - 70, overflow: 'auto' }}>
					<div>
						<Calendar
							onSelect={this.handleChangeCalDate}
							width={cal_width}
							height={cal_height}
							left={(this.props.width - 20) * 0.05}
							max_date={new Date()}
							selected_date={this.state.selected_date}
						/>
					</div>
					{/* <div style={{ marginTop: cal_height + 167, paddingBottom: 60, height: this.props.height - cal_height - 167 - 105, overflow: 'auto' }}> */}
						<div style={{...header_style, marginTop: cal_height + 167}}>
							<span className="header">{this.props.receiver.getString('order')}</span>
						</div>
						<div style={content_line_style}>
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span>{this.props.receiver.getString('order')}</span>
							</div>
							<div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}>
								<Select
									options={order_range}
									value={this.state.order}
									onSelect={this.handleChangeOrder}
								/>
							</div>
						</div>
						<div style={header_style}>
							<span className="header">{this.props.receiver.getString('hist_filter')}</span>
						</div>
						<div style={content_line_style}>
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span>{this.props.receiver.getString('type')}</span>
							</div>
							<div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}>
								<Select
									options={type_range}
									value={this.state.type}
									onSelect={this.handleChangeType}
								/>
							</div>
						</div>
						<div style={content_line_style}>
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span>{this.props.receiver.getString('command')}</span>
							</div>
							<div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}>
								<Select
									options={command_range}
									value={this.state.command}
									onSelect={this.handleChangeCommand}
								/>
							</div>
						</div>
						<div style={content_line_style}>
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span>{this.props.receiver.getString('target')}</span>
							</div>
							<div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}>
								<Select
									options={target_range}
									value={this.state.target}
									onSelect={this.handleChangeTarget}
								/>
							</div>
						</div>
						<div style={{...content_line_style, paddingBottom: 100}}>
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span>{this.props.receiver.getString('operator')}</span>
							</div>
							<div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}>
								<Select
									options={operator_range}
									value={this.state.operator}
									onSelect={this.handleChangeOperator}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}